

<template>
  <div>
    <vuestic-modal
      show.sync="true"
      ref="mediumModal"
      :okText="'upgrade.payInvoice' | translate"
      v-on:ok="confirm"
      :cancelText="'modal.cancel' | translate"
    >
      <div slot="title">{{$t('upgrade.existingInvoiceTitle')}}</div>
      <div>{{$t('upgrade.existingInvoiceBody')}}</div>
    </vuestic-modal>
  </div>
</template>

<script>
import configs from 'services/configs'
import iframeUtil from '../../services/iframeUtil';

export default {
  props: {
    unpaidInvoice: {
      type: Object,
      required: true
    }
  },
  methods: {
    openModal () {
      this.$refs.mediumModal.open()
    },
    confirm () {
      this.showToast(this.$t('upgrade.step4Title'), {
        icon: 'fa-star-o',
        position: 'top-center',
        duration: 4000,
        fullWidth: false
      })
      
      // Send redirect event to parent window
      iframeUtil.sendEventToParent('redirect', {
        invoiceId: this.unpaidInvoice.id,
      })

      var invoiceUrl = configs.CLIENT_AREA() + 'viewinvoice.php?id=' + this.unpaidInvoice.id
      window.location.replace(invoiceUrl)
    }
  }
}
</script>

<style>
.custom-actions button.ui.button {
  padding: 8px 8px;
}
.custom-actions button.ui.button > i.icon {
  margin: auto !important;
}
</style>


// WEBPACK FOOTER //
// src/components/upgrade/ExistingInvoiceAction.vue